var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:_vm.buttonInfo.class,on:{"click":_vm.addToCart}},[_vm._v("\n    "+_vm._s(_vm.buttonInfo.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }